/* eslint-disable @atlassian/tangerine/import/entry-points */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React, { memo } from 'react';
import Text from '@atlaskit/ds-explorations/text';
import { Box, xcss } from '@atlaskit/primitives';
import { formatValue } from './internal/utils';
var boxStyles = xcss({
  borderRadius: 'border.radius.200',
  display: 'inline-flex',
  blockSize: 'min-content'
});

/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */
var Badge = /*#__PURE__*/memo(function Badge(_ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? 0 : _ref$children,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 99 : _ref$max,
    style = _ref.style,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Box, {
    testId: testId,
    as: "span",
    backgroundColor: backgroundColors[appearance],
    xcss: boxStyles,
    style: style !== null && style !== void 0 && style.backgroundColor ? {
      backgroundColor: style.backgroundColor
    } : undefined,
    paddingInline: "space.075"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "size.075",
    lineHeight: "lineHeight.100",
    textAlign: "center",
    color: textColors[appearance],
    UNSAFE_style: style !== null && style !== void 0 && style.color ? {
      color: style.color
    } : undefined
  }, typeof children === 'number' && max ? formatValue(children, max) : children));
});
Badge.displayName = 'Badge';
export default Badge;
var backgroundColors = {
  added: 'color.background.success',
  default: 'color.background.neutral',
  important: 'color.background.danger.bold',
  primary: 'color.background.brand.bold',
  primaryInverted: 'elevation.surface',
  removed: 'color.background.danger'
};
var textColors = {
  added: 'success',
  default: 'color.text',
  important: 'inverse',
  primary: 'inverse',
  primaryInverted: 'brand',
  removed: 'danger'
};